import React from 'react';
import PropTypes from 'prop-types';

import TableCell from '@mui/material/TableCell';

import FormatDollarAmount from '../FormatDollarAmount.jsx';

function GrossTieredCell({ amount, cumulativeBasis, tier2Start, tier3Start, isTotal, dataCy }) {
  let backgroundColor = 'aquamarine';

  if (isTotal || cumulativeBasis <= tier2Start) {
    backgroundColor = 'paper';
  } else if (cumulativeBasis <= tier3Start) {
    backgroundColor = 'aqua';
  }

  return (
    <TableCell
      data-cy={dataCy}
      sx={(theme) => ({
        backgroundColor:
          backgroundColor === 'paper' ? theme.palette.background.paper : backgroundColor,
        color: backgroundColor !== 'paper' ? theme.palette.common.black : undefined,
      })}
    >
      <FormatDollarAmount amount={amount} />
    </TableCell>
  );
}

GrossTieredCell.propTypes = {
  amount: PropTypes.number.isRequired,
  cumulativeBasis: PropTypes.number.isRequired,
  tier2Start: PropTypes.number.isRequired,
  tier3Start: PropTypes.number.isRequired,
  isTotal: PropTypes.bool,
  dataCy: PropTypes.string,
};

export default React.memo(GrossTieredCell);
